<template>
  <div>
    <gg-card-title>
      Promotions
    </gg-card-title>
    <v-card class="app-card">
      <v-card-text>
        <gg-loading :loading="loading" type="table">
          <v-data-table
          :headers="headers"
          :items="promotions"
          sort-by="promo_request_id"
          sort-desc
          :footer-props="{ itemsPerPageOptions: pagination }"
        >
          <template v-slot:item.promo_request_id="{ item }">
            <router-link :to="`/promotions/view/${item.promo_request_id}`">
              <strong>#{{ item.promo_request_id }}</strong>
            </router-link>
          </template>
          <template v-slot:item.promo_status="{ item }">
            <v-icon small class="pb-1" :color="statusColor(item.promo_status)">mdi-circle</v-icon>
            {{ statusNameFormatter(item.promo_status) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <gg-btn :to="`/promotions/view/${item.promo_request_id}`">
              View Details
            </gg-btn>
          </template>
        </v-data-table>
        </gg-loading>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { statusColor, statusNames } from 'Helpers/helpers'

// const statusNames = {
//   pending: 'Pending',
//   completed: 'Completed',
//   escalated: 'Escalated',
//   closed: 'Closed',
// }

export default {
  name: 'PromotionsList',
  data: () => ({
    headers: [
      { text: 'ID Number', sortable: true, value: 'promo_request_id' },
      { text: 'Status', sortable: true, value: 'promo_status' },
      { text: 'Date Generated', sortable: true, value: 'date_generated' },
      { text: 'Actions', sortable: false, value: 'actions', align: 'center' },
    ],
    loading: false
  }),
  async mounted () {
    await this.getPromotions()
  },
  computed: {
    ...mapGetters(['promotions', 'pagination'])
  },
  methods: {
    ...mapActions(['getPromoList', 'reportSuccess', 'reportError']),
    statusColor,
    statusNameFormatter (name) {
      return statusNames[name]
    },
    async getPromotions () {
      try {
        this.loading = true
        await this.getPromoList()
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    }
  }
}
</script>
